import React from 'react';

// Renders nothing visible but participates in the form so the value still
// flows through validation + submit. Use with FormField for a value the
// user shouldn't see/edit but that the schema needs.
export default function HiddenField({ field, id }) {
  return (
    <input
      type="hidden"
      id={id}
      name={field.name}
      value={field.value ?? ''}
      onChange={field.onChange}
    />
  );
}
